import React, { FC } from 'react';
import { FooterLink } from '../../../../types/types';
import { FooterLinkModel } from '../../../../lib/shared-models/FooterLink.model';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../../@shared/icon';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';

const MarketSelector: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  return (
    <div className="market-selector">
      <RoutableNotEditableLink className="market-selector__link" href={model.link?.value?.href ?? ''}>
        <Icon iconName="social-sharing-globe" size={iconSize.md} color="gray" extraClassName="market-selector__icon--globe" />
        <span className="market-selector--content">{model.title?.value}</span>
        <Icon iconName="arrow-chevron-right" size={iconSize.md} color="gray" />
      </RoutableNotEditableLink>
    </div>
  );
};

export default MarketSelector;
